// src/firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBhYyW-2s0klnU3oGhSBAoCRUTuBKd8aA",
  authDomain: "josewebsite-c6c8e.firebaseapp.com",
  databaseURL: "https://josewebsite-c6c8e-default-rtdb.firebaseio.com",
  projectId: "josewebsite-c6c8e",
  storageBucket: "josewebsite-c6c8e.appspot.com", // Fixed storageBucket URL
  messagingSenderId: "616788104695",
  appId: "1:616788104695:web:78073c2c66ffe986004af2",
  measurementId: "G-1DMKGJSRYK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services and export them
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const database = getDatabase(app);

export default app;